<div class="w-full flex flex-col items-center">
    <div class="flex items-center justify-center gap-[23px] w-full h-[340px] px-2">
        @for (post of posts; track post.slug) {
        <div class="w-[400px]" [class.slide-in]="showPosts()">
            <app-blog-card [post]="post"></app-blog-card>
        </div>
        }
    </div>
    <div class="flex items-center justify-center gap-[23px] w-full mt-[40px] value">
        <div (click)="activateCarousel(step.value)" *ngFor="let step of carouselSteps"
            class="w-3 h-3 bg-gray-500 rounded-full" [ngStyle]="step.active ? {'background-color': '#7E47F3'} : {}">
        </div>
    </div>
</div>